//@flow
import { connect } from 'react-redux';
import SuspensionStatus from './SuspensionStatus';
import {
  isCurrentSubscriptionSuspendedSelector,
  isCurrentSubscriptionPendingSuspendedSelector,
  isSubscriptionSuspendedByCustomerSelector,
} from '../../../../modules/Dashboard';
import { unsuspendLine } from '../../../../modules/SuspendSwapTerminate';

import type { StateProps, DispatchProps } from './SuspensionStatus';
import type { StateType } from '../../../../modules/reducers';

const mapStateToProps = (state: StateType): StateProps => ({
  isSuspended: isCurrentSubscriptionSuspendedSelector(state),
  isPendingSuspended: isCurrentSubscriptionPendingSuspendedSelector(state),
  isSuspendedByCustomer: isSubscriptionSuspendedByCustomerSelector(state),
  loadingSelector: 'unsuspendSuccess',
});

const mapDispatchStateToProps: DispatchProps = {
  unsuspendLine,
};

export default connect(mapStateToProps, mapDispatchStateToProps)(SuspensionStatus);
